import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { PATH_TAGS_FEATURE } from "./consts";
import tagsFeatureReducer from "./reducers";
import * as tagsSelectors from "./selectors/tags";

const reducerRegistry = ReducerRegistry.getInstance();
reducerRegistry.initialise(PATH_TAGS_FEATURE, builder => {
  builder.register(PATH_TAGS_FEATURE, tagsFeatureReducer);
});

//models
export { default as Category } from "./models/Category";
export { default as Tag } from "./models/Tag";
export { default as TagsFeature } from "./models/TagsFeature";

//selectors
export {
  applyPremiumStyleToFilter,
  findCategoryIdByName,
  findTagIdByName,
  getAllTagIds,
  getAllTags,
  getCategoryIdBySemanticCategory,
  getCategoryIds,
  getCategoryName,
  getCategorySemanticCategory,
  getCategoryTagIds,
  getFirstRootCategoryId,
  getRootCategoriesDropdownOptions,
  getRootTagHierarchy,
  getStateCategories,
  getStateTags,
  getTagCoursesFilterOnly,
  getTagDescription,
  getTagName,
  getParentId as getTagParentId,
  getTagSemanticCategory,
  getTagSubjectGroup,
  getVisibleRootCategoryIds,
  getVisibleRootCategoryIdsWithoutPrice,
  hasRootTag,
  isSectionPreviewEnabled,
  makeGetCategoryTags,
  showAssignmentSelfMarkedQuestions,
  showCardAdTagIdsOnYourCoursesPage
} from "./selectors";

export {
  getVisibleTagIdByCategoryNameAndTagName,
  getVisibleTagIdBySemanticCategoryAndTagName
} from "./selectors/getVisibleTagIdBySemanticCategoryAndTagName";

export {
  getFetchTagsError,
  getFetchTagsLastFetched,
  // FETCH ALL
  getFetchTagsStarted,
  getFetchTagsSuccess,
  tagsHaveFinishedFetching,
  tagsNeedFetching
} from "./selectors/meta";

export { tagsSelectors };

// actions
export { receiveTagsAndCategories } from "./actions";
export { fetchAllTagsActionFactory } from "./actions/meta";

//reducers
export { default as tagsFeatureReducer } from "./reducers";
